<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                 :size="GCONFIG.styleElFormSize">
            <el-form-item label="页面标题">
                <el-input v-model=formInline.pageTitle clearable placeholder="页面标题 支持模板查询"></el-input>
            </el-form-item>
            <el-form-item label="页面连接">
                <el-input v-model=formInline.pageLink clearable placeholder="请输入页面连接 支持模板查询"></el-input>
            </el-form-item>
            <el-form-item label="活动类型">
                <el-select v-model="formInline.activeType" clearable filterable placeholder="请选择活动类型" >
                    <el-option
                            v-for="item in activeTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" size="mini" @click="getList()">查询</el-button>
                    <el-button type="success" size="mini" @click="handleAdd()">新增</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>

        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="linkId" label="标识" width="100"></el-table-column>
            <el-table-column prop="pageTitle" label="页面标题" width="100"></el-table-column>
            <el-table-column prop="pageLink" label="页面连接" width="100"></el-table-column>
            <el-table-column prop="pageLinkPara" label="连接参数" width="150"></el-table-column>
            <el-table-column prop="linkTypeName" label="页面类型" width="100"></el-table-column>
            <el-table-column prop="activeTypeName" label="活动类型" width="100">
            </el-table-column>
            <el-table-column prop="remark" label="备注说明" width="100"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="danger" size="mini"
                                   @click="handDelete(scope.row)">删除
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getValidDictionaryList, getPageLinkList,deletePageLink} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                listData: [],
                platformData: [],
                loading: false,
                activeTypeList: [],
                form: {
                    linkId: '',
                    pageTitle: '',
                    pageLink: '',
                    linkTpye: '',
                    activeType: '',
                    createTime: '',
                    remark: ''
                },
                formInline: {
                    currentPage: 1,
                    pageSize: 15,
                    pageTitle: '',
                    pageLink: '',
                    linkTpye: '',
                    activeType: '',
                    recordsTotal: 0,
                },
                platformDisabled: false
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
            this.getActiveTypeList();
        },
        methods: {
            //定义查询方法
            getList(){
                this.loading = true;
                getPageLinkList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value.list;
                })
            },
            getActiveTypeList(){
                getValidDictionaryList({"platformGroupId": 1000,"dictionaryTypeId":203, "currentPage": 1,
                    "pageSize": 50,}).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.activeTypeList=[];
                        for(let v of res.data.value.list) {
                            let type={};
                            type.id=parseInt(v.dictionaryKey);
                            type.name=v.dictionaryName;
                            this.activeTypeList.push(type);
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd(row){
                this.$router.push({name: 'pageDetail',params:{id:0}})
            },
            handleEdit(data){
                this.$router.push({name: 'pageDetail',params:{id:data.linkId}})
            },
            handDelete(row){
                if (confirm("删除不可撤销，确认删除吗？")) {
                    this.loading = true;
                    deletePageLink({linkId: row.linkId}).then((res) => {
                        this.loading = false;
                        if (res.data.success) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            returnHistory(){
                window.history.back()
            }
        }
    }

</script>
<style>
    .p {
        color: red
    }
</style>



// WEBPACK FOOTER //
// src/views/pageconfig/pageLinkList.vue